import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
import stocksHistoryController from "./StocksHistoryController"
import {Link, match, Route, useHistory} from "react-router-dom"

import {appPages} from "../../App";
import {SkeletonBox} from "../../lib/wa-2.0"
import ReactPaginate from "react-paginate"


const ProductHistoryComponent = observer(({match}: { match: match<{ product_id: string}> }) => {
    const product_id = match.params.product_id

    useEffect(() => {
        stocksHistoryController.isNewProduct(product_id) && stocksHistoryController.loadProductData(product_id)
    }, [product_id])

    // const history = useHistory();
    // const handleRowClick = (id: number) => {
    //     history.push(appPages.stocksHistory + '/product/' + stocksHistoryController.productId + '/product/'+id);
    // }
    const links =[]
    if(stocksHistoryController.productsLoaded && stocksHistoryController.productInfo) {

        links.push({
            url: window.location.origin+'/webasyst/shop/?action=products#/product/' + stocksHistoryController.productInfo.id,
            label: 'Товар в Shop-script'
        })
        if (stocksHistoryController.productId != 0) {
            links.push({
                url: 'https://seller.ozon.ru/app/products/' + stocksHistoryController.productId + '/edit/general-info',
                label: 'Товар в Ozon'
            })
        }
    }

    return <div>
        <h1>История обновлений</h1>
        <Link  className="button" to={appPages.stocksHistory}>Назад</Link>
        {stocksHistoryController.productsLoaded && stocksHistoryController.productInfo
        && <div style={{margin: '10px 70px', fontWeight:500}}>{stocksHistoryController.productInfo.name}</div>}
        {links.length > 0 &&
        <div>
            {links.map((link, index) =>
                <span key={index} style={{margin:'0 1em'}}>
                    <a target={'_blank'} href={link.url}>{link.label} <i className="fas fa-external-link-alt" aria-hidden="true"/></a>
                </span>
            )}
        </div>}
        {stocksHistoryController.productsLoaded ? <table>
            <thead style={{backgroundColor: "#F3F3F3"}}>
                <tr>
                    <th>Дата</th>
                    <th>Склад</th>
                    <th>Количество товара</th>
                </tr>
            </thead>
            <tbody>
            {stocksHistoryController.productInfo && stocksHistoryController.productInfo.history.map((item, index) =>
                <tr key={index} style={{cursor:'pointer'}}>
                    <td>{item.datetime}</td>
                    <td>{item.warehouse_id}</td>
                    <td>{item.count}</td>
                </tr>
            )}
            </tbody>
        </table> : <SkeletonBox/>}
        {stocksHistoryController.pCountOfPages > 1 &&
        <div className={'paginate-compare'}>
            <ReactPaginate
                previousLabel={'Предыдущая'}
                nextLabel={'Следующая'}
                containerClassName={'paging'}
                pageCount={stocksHistoryController.pCountOfPages}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                initialPage={stocksHistoryController.pPage}
                onPageChange={({selected}) => {
                    stocksHistoryController.loadProductData(product_id, selected)
                }
                }
            />
        </div>}
    </div>
})

export default ProductHistoryComponent